import { setDocuments } from "./directories/auxiliary";
import { setDocumentChar } from "./directories/document-characteristics";
import { setHrDepartment } from "./directories/hr-department";
import { setGeneral } from "./directories/general";
import { setAdministration } from "./administration";
import { setProfile } from "./profile";

export const setFieldValuesFunctions = {
  ...setDocuments,
  ...setDocumentChar,
  ...setHrDepartment,
  ...setGeneral,
  ...setAdministration,
  ...setProfile
};
